import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import Field from '../../fields/Field';
import FieldEmail from '../../fields/FieldEmail';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../../lang/main';
import useFormState from '../../FormStateHelper';
import { validateForm } from '../../../selectors/defaultSelectors';

const FORM_LABEL = {
    Reference2Name: getTranslation('FIELD.PURCHASE_DEPT_CONTACT'),
    Reference2Email: getTranslation('FIELD.PURCHASE_DEPT_EMAIL'),
    Reference2Phone: getTranslation('FIELD.PURCHASE_DEPT_PHONE'),
};

function AccountResellerPurchaseDeptForm(props) {
    const { data, handleFormSubmission } = props;
    const {
        formData,
        bindUpdateFormData,
        isSubmitting,
        submitForm,
    } = useFormState({
        handleFormSubmission: handleFormSubmission,
        initialFormState: {},
    });
    const [isValidated, setIsValidated] = useState(false);
    let fieldRefs = {};

    const finalFormData = {
        ...data,
        ...formData,
    };

    const onFormSubmit = (e) => {
        e.preventDefault();

        submitForm(finalFormData);
    };

    const onFieldUpdate = (e) => {
        bindUpdateFormData(e);
    };

    // Effects
    // --------------------
    // - Validate form
    useEffect(() => {
        setIsValidated(!validateForm(fieldRefs));
    }, [finalFormData]);

    return (
        <React.Fragment>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <span className='icon icon-reseller-thick' />
                    </span>
                </span>
                <h3 className='heading heading--lv4'>
                    <LocalizedMessage
                        id={'ACCOUNT_RESELLER_PURCHASE_DEPT_FORM.HEADING'}
                    />
                </h3>
            </div>
            <form className='form' onSubmit={onFormSubmit}>
                <div className='row'>
                    <div className='col-xs-12 col-md-7 vspace vspace--small'>
                        <div className='row row--small'>
                            <div className='col-xs-12'>
                                <Field
                                    required
                                    ref={(r) => (fieldRefs.Reference2Name = r)}
                                    label={FORM_LABEL['Reference2Name']}
                                    animatedLabel={FORM_LABEL['Reference2Name']}
                                    name='Reference2Name'
                                    value={finalFormData.Reference2Name || ''}
                                    onChange={onFieldUpdate}
                                />
                            </div>
                        </div>
                        <div className='row row--small'>
                            <div className='col-xs-12 col-sm-6'>
                                <FieldEmail
                                    required
                                    ref={(r) => (fieldRefs.Reference2Email = r)}
                                    label={FORM_LABEL['Reference2Email']}
                                    animatedLabel={
                                        FORM_LABEL['Reference2Email']
                                    }
                                    name='Reference2Email'
                                    value={finalFormData.Reference2Email || ''}
                                    onChange={onFieldUpdate}
                                />
                            </div>
                            <div className='col-xs-12 col-sm-6'>
                                <Field
                                    required
                                    ref={(r) => (fieldRefs.Reference2Phone = r)}
                                    label={FORM_LABEL['Reference2Phone']}
                                    animatedLabel={
                                        FORM_LABEL['Reference2Phone']
                                    }
                                    name='Reference2Phone'
                                    value={finalFormData.Reference2Phone || ''}
                                    onChange={onFieldUpdate}
                                />
                            </div>
                        </div>

                        <button
                            type='submit'
                            className={`form__submit button ${
                                !isValidated ? 'button--disabled' : ''
                            }`}
                            disabled={!isValidated}
                        >
                            <span
                                style={{
                                    opacity: isSubmitting === true ? 0 : 1,
                                }}
                            >
                                <LocalizedMessage id={'SAVE'} />
                            </span>
                            {isSubmitting === true && (
                                <ReactLoading
                                    className='button__spinner'
                                    type='spin'
                                    color='white'
                                    height={20}
                                    width={20}
                                />
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );
}

export default AccountResellerPurchaseDeptForm;
